import React, { Fragment } from 'react'
import { TextBoxMaxLine1Headline3 } from 'atoms/TextBox/Templates'
import { FIXED_INDENTS } from 'vars/index'
import { ButtonPayment, PaymentOptionPopupSC } from './PopupComponents.styled'

export interface ICardSelectPopup {
  children: React.ReactNode | React.ReactNode[]
  columnGap?: FIXED_INDENTS
  rowGap?: FIXED_INDENTS
  title: string
}

export const CardSelectPopup = ({
  rowGap = FIXED_INDENTS.INDENT_20,
  children,
  title,
}: ICardSelectPopup) => {
  const components = React.Children.toArray(children)
  const hasOnePaymentOption: boolean = components.length === 2
  const sliceIndex = hasOnePaymentOption ? 1 : -1
  const bodyChild = components.slice(0, sliceIndex)
  const lastChild: React.ReactNode = components.slice(-1)
  return (
    <PaymentOptionPopupSC rowGap={rowGap}>
      <TextBoxMaxLine1Headline3 title={title} />
      {bodyChild.map((item, index) => (
        <Fragment key={index}>{item}</Fragment>
      ))}
      <ButtonPayment>{lastChild}</ButtonPayment>
    </PaymentOptionPopupSC>
  )
}
